
import { useEffect } from "react";
import { useRouteError } from "react-router-dom";

type RouteErrorProps={
    data: string | null
    status: number
    statusText:string,
}

export default function ErrorPage() {
  const error:RouteErrorProps|any= useRouteError();
  useEffect(()=>{
      window.location.replace("https://www.innovationmatch.io/it/error")
  },[])

  return (
    <div id="error-page">
      
    </div>
  );
}